/** Author: Codex CLI Agent // Generation: P1 timing optimization // Version: v3.2.273 // Modified: 2025-12-06T20:07:46-08:00 // One-line: 缩短收集与用药动画耗时 */
export const COMBAT_TIMING_CONSTANTS = {
  ATTACK_SEGMENT_MS: 500,
  MISS_SEGMENT_MS: 500,
  HURT_ALIGN_MS: 400, // 受击帧对齐
  DEATH_SEGMENT_MS: 600,
  CURTAIN_CLOSE_MS: 100,
  MAP_DEATH_CLEANUP_MS: 800,
  PREPARE_MS: 100, // 战斗前准备（开场排布/idle收束）
  INTER_STEP_MS: 800, // 分段之间的节拍延时（Sequencer COMBAT_STEP_DELAY）
  COLLECT_SEGMENT_MS: 300,
} as const;

export function computeCombatPlannedDuration(
  attackCount: number,
  missCount: number,
  hasDeath: boolean = true,
): number {
  const clampedAttacks = Math.max(0, attackCount | 0);
  const clampedMisses = Math.max(0, missCount | 0);
  const steps = clampedAttacks + clampedMisses;
  const baseSegments = (clampedAttacks * (COMBAT_TIMING_CONSTANTS.ATTACK_SEGMENT_MS + COMBAT_TIMING_CONSTANTS.HURT_ALIGN_MS))
    + (clampedMisses * COMBAT_TIMING_CONSTANTS.MISS_SEGMENT_MS);
  const interGap = steps > 1 ? (steps - 1) * COMBAT_TIMING_CONSTANTS.INTER_STEP_MS : 0;
  const base = COMBAT_TIMING_CONSTANTS.PREPARE_MS + baseSegments + interGap + COMBAT_TIMING_CONSTANTS.CURTAIN_CLOSE_MS;
  const deathBudget = hasDeath
    ? (COMBAT_TIMING_CONSTANTS.DEATH_SEGMENT_MS + COMBAT_TIMING_CONSTANTS.MAP_DEATH_CLEANUP_MS)
    : 0;
  return base + deathBudget;
}

// Movement: per-step planned duration（取整500ms，含帧延迟+tween）
export function computeMovePlannedDuration(stepCount: number): number {
  const steps = Math.max(0, stepCount | 0);
  return steps * 500;
}

// Use-item: 单次固定时长（缩短至 ~0.7s，减轻队列堆积）
export function computeUseItemPlannedDuration(): number {
  return 700;
}

export function computeCollectPlannedDuration(): number {
  return COMBAT_TIMING_CONSTANTS.COLLECT_SEGMENT_MS;
}
